/**
 * Author：brand
 * Creation Time：2019-06-05 14:33
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 二维码名片相关接口 ⬇
 * @param params
 * @returns {*}
 */
export function uploadQRCodeAPI (params) {
  return ax({
    url: '/wlapi/wxBusinCard/upload',
    method: 'POST',
    data:params,
  })
}
export function getQRCodelistAPI (params) {
  return ax({
    url: '/wlapi/wxBusinCard/cardlist',
    method: 'POST',
    params,
  })
}
export function delQRCodeAPI (params) {
  return ax({
    url: '/wlapi/wxBusinCard/delcard',
    method: 'POST',
    data:params,
  })
}


/**
 * 短信相关接口    ⬇
 * @param params
 * @returns {*}
 */
export function getMsgNumAPI (params) {
  return ax({
    url: '/wlapi/message/surplusMsgCount',
    method: 'POST',
    params,
  })
}

export function msgSendRecordAPI (params) {
  return ax({
    url: '/wlapi/message/msgSendRecord',
    method: 'POST',
    params,
  })
}
export function msgRechargeRecordAPI (params) {
  return ax({
    url: '/wlapi/message/msgRechargeList',
    method: 'POST',
    params,
  })
}

export function msgRechargePackageAPI (params) {
  return ax({
    url: '/wlapi/message/msgPackage',
    method: 'POST',
    params,
  })
}


export function msgPayAPI (params) {
  return ax({
    url: '/wlapi/message/pay',
    method: 'POST',
    params,
  })
}



/**
 * 访客黑名单    ⬇
 * @param params
 * @returns {*}
 */
export function getBlackListAPI (params) {
  return ax({
    url: '/wlapi/black/blackList',
    method: 'POST',
    params,
  })
}
export function removeBlackListAPI (params) {
  return ax({
    url: '/wlapi/chat/blackRemove',
    method: 'POST',
    params,
  })
}
/**
 * ip黑名单    ⬇
 * @param params
 * @returns {*}
 */
export function getIpBlackListAPI (params) {
  return ax({
    url: '/wlapi/black/ipBlackList',
    method: 'POST',
    params,
  })
}
export function addIpBlackAPI (params) {
  return ax({
    url: '/wlapi/black/addIpBlack',
    method: 'POST',
    params,
  })
}
export function editIpBlackAPI (params) {
  return ax({
    url: '/wlapi/black/editIpBlack',
    method: 'POST',
    params,
  })
}
export function delIpBlackAPI (params) {
  return ax({
    url: '/wlapi/black/delIpBlack',
    method: 'POST',
    data:params,
  })
}
/**
 * 标签    ⬇
 * @param params
 * @returns {*}
 */
export function getTagListAPI (params) {
  return ax({
    url: '/wlapi/tag/getTagList',
    method: 'POST',
    params,
  })
}
export function addTagAPI (params) {
  return ax({
    url: '/wlapi/tag/add',
    method: 'POST',
    params,
  })
}
export function editTagAPI (params) {
  return ax({
    url: '/wlapi/tag/edit',
    method: 'POST',
    params,
  })
}
export function delTagAPI (params) {
  return ax({
    url: '/wlapi/tag/delete',
    method: 'POST',
    params,
  })
}


/**
 * 语音设置
 * @param params
 * @returns {*}
 */
export function gzhInfoAPI (params) {
  return ax({
    url: '/wlapi/audioWxgzh/gzhInfo',
    method: 'POST',
    params,
  })
}
export function saveGzhInfoAPI (params) {
  return ax({
    url: '/wlapi/audioWxgzh/save',
    method: 'POST',
    params,
  })
}

export function uploadWxFileAPI (params) {
  return ax({
    url: '/wlapi/audioWxgzh/uploadVoiceVerify',
    method: 'POST',
    data:params,
  })
}
export function getWxFileAPI (params) {
  return ax({
    url: '/wlapi/audioWxgzh/getVoiceVerify',
    method: 'POST',
    params,
  })
}



/**
 * 机器人
 * @param params
 * @returns {*}
 */
export function getRobotConfigAPI (params) {
  return ax({
    url: '/wlapi/robot/getRobotSet',
    method: 'POST',
    params,
  })
}
export function robotConfigSettingAPI (params) {
  return ax({
    url: '/wlapi/robot/robotSetting',
    method: 'POST',
    params,
  })
}

export function getRobotInfoAPI (params) {
  return ax({
    url: '/wlapi/robot/robotInfo',
    method: 'POST',
    params,
  })
}
export function editRobotInfoAPI (params) {
  return ax({
    url: '/wlapi/robot/editRobotInfo',
    method: 'POST',
    params,
  })
}
export function geiRobotMsgNumAPI (params) {
  return ax({
    url: '/wlapi/robot/robotMessageCount',
    method: 'POST',
    params,
  })
}
export function robotCommonProblemList (params) {
  return ax({
    url: '/wlapi/robot/robotCommonProblemList',
    method: 'POST',
    params,
  })
}
export function addCommonProblem (params) {
  return ax({
    url: '/wlapi/robot/addCommonProblem',
    method: 'POST',
    params,
  })
}
export function delCommonProblem (params) {
  return ax({
    url: '/wlapi/robot/delCommonProblem',
    method: 'POST',
    params,
  })
}

/**
 * 对话邀请
 * @param params
 * @returns {*}
 */

export function getInviteConfigAPI (params) {
  return ax({
    url: '/wlapi/dialInviteSet/getDialogueSet',
    method: 'POST',
    params,
  })
}

/**
 * 知识库
 * @param params
 * @returns {*}
 */

// 分类列表
export function getClassListAPI (params) {
  return ax({
    url: '/wlapi/knowledge/searchClass',
    method: 'POST',
    params,
  })
}
// 分类-添加-编辑
export function addOrEditClassAPI (params) {
  return ax({
    url: '/wlapi/knowledge/editOrAddClass',
    method: 'POST',
    params,
  })
}
// 分类-删除
export function delClassAPI (params) {
  return ax({
    url: '/wlapi/knowledge/delClass',
    method: 'POST',
    params,
  })
}
// 知识库管理-列表
export function getKnowledgeListAPI (params) {
  return ax({
    url: '/wlapi/knowledge/searchProblem',
    method: 'POST',
    params,
  })
}
// 知识库管理-增加、编辑问题
export function addOrEditProblemAPI (params) {
  return ax({
    url: '/wlapi/knowledge/addOrEditProblem',
    method: 'POST',
    data:params,
  })
}
// 知识库管理-删除问题
export function delProblemAPI (params) {
  return ax({
    url: '/wlapi/knowledge/delProblem',
    method: 'POST',
    data:params
  })
}

// 知识库管理-导入数据
export function importDataAPI (params) {
  return ax({
    url: '/wlapi/knowledge/inExecl',
    method: 'POST',
    data:params,
  })
}
// 寒暄库-导入数据
export function greetingLibImportAPI (params) {
  return ax({
    url: '/wlapi/knowledge/greetingLibImport',
    method: 'POST',
    data:params,
  })
}


/**
 * 获取快捷回复分类
 * @param params
 * @returns {*}
 */
// 快捷回复-分类列表
export function getCategoryListAPI (params) {
  return ax({
    url: '/wlapi/reply/mpQrGroupList',
    method: 'GET',
    params,
  })
}

// 快捷回复-分类-类型
export function getCategoryTypeAPI (params) {
  return ax({
    url: '/wlapi/reply/outQr',
    method: 'GET',
    params,
  })
}

// 快捷回复-分类-添加
export function addCategoryDataAPI (params) {
  return ax({
    url: '/wlapi/reply/addQrGroup',
    method: 'GET',
    params,
  })
}
// 快捷回复-分类-编辑
export function editCategoryDataAPI (params) {
  return ax({
    url: '/wlapi/reply/renameQrGroup',
    method: 'GET',
    params,
  })
}
// 快捷回复-分类-删除
export function delCategoryDataAPI (params) {
  return ax({
    url: '/wlapi/reply/deleteQrGroup',
    method: 'GET',
    params,
  })
}

// 快捷回复-企业回复(个人回复)-列表
export function ReplyContentDetailAPI (params) {
  return ax({
    url: '/wlapi/reply/quickReplaySub',
    method: 'GET',
    params,
  })
}
// 快捷回复-企业回复(个人回复)-删除
export function delReplyContentAPI (params) {
  return ax({
    url: '/wlapi/reply/delete',
    method: 'GET',
    params,
  })
}
// 快捷回复-企业回复(个人回复)-批量删除
export function delSomeReplyContentAPI (params) {
  return ax({
    url: '/wlapi/reply/batchDelete',
    method: 'POST',
    data:params,
  })
}
// 快捷回复-分类列表-批量删除
export function delSomeCategoryContentAPI (params) {
  return ax({
    url: '/wlapi/reply/batchDeleteQrGroup',
    method: 'POST',
    data:params,
  })
}

// 快捷回复-企业回复(个人回复)-添加
export function addReplyContentAPI (params) {
  return ax({
    url: '/wlapi/reply/add',
    method: 'POST',
    params,
  })
}
// 快捷回复-企业回复(个人回复)-编辑
export function editReplyContentAPI (params) {
  return ax({
    url: '/wlapi/reply/edit',
    method: 'POST',
    params,
  })
}

// 快捷回复-导入
export function importReplyContentAPI (params) {
  return ax({
    url: '/wlapi/reply/importQrExecl',
    method: 'POST',
    data:params,
  })
}
  // 群发-  获取 访客列表
export function getMassVisitorListAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/searchVisitors',
    method: 'POST',
    params,
  })
}
  // 群发-发送
export function sendMassMsgAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/createSendall',
    method: 'POST',
    data: params,
  })
}
  // 群发--发送列表
export function sendMassListAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/list',
    method: 'POST',
     params,
  })
}

  // 群发--删除
export function delMassMsgAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/delSendall',
    method: 'POST',
     params,
  })
}
  // 群发--获取标签列表
export function getMassTagListAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/asynTagsList',
    method: 'POST',
     params,
  })
}

  // 群发--根据标签获取访客列表
export function getMassVisitorByTagAPI (params) {
  return ax({
    url: '/wlapi/msgSendall/searchTagVisitors',
    method: 'POST',
     params,
  })
}
  // 机器人-自动开启时间
export function setRobotAutoTimeAPI (params) {
  return ax({
    url: '/wlapi/robot/autoRobotTime',
    method: 'POST',
    params,
  })
}

// 机器人引导转人工文字列表
export function redirectContentListAPI (params) {
  return ax({
    url: '/wlapi/autoRedirect/redirectContentList',
    method: 'POST',
    params,
  })
}

// 机器人引导转人工添加
export function addRedirectContentAPI (params) {
  return ax({
    url: '/wlapi/autoRedirect/addRedirectContent',
    method: 'POST',
    params,
  })
}

// 机器人引导转人工编辑
export function editRedirectContentAPI (params) {
  return ax({
    url: '/wlapi/autoRedirect/editRedirectContent',
    method: 'POST',
    params,
  })
}

// 机器人引导转人工删除
export function delRedirectContentAPI (params) {
  return ax({
    url: '/wlapi/autoRedirect/delRedirectContent',
    method: 'POST',
    params,
  })
}


// 寒暄库管理-列表
export function getGreetingLibListAPI (params) {
  return ax({
    url: '/wlapi/knowledge/greetingLibList',
    method: 'POST',
    params,
  })
}
// 寒暄库管理-增加、编辑
export function addOrEditGreetingAPI (params) {
  return ax({
    url: '/wlapi/knowledge/addOrEditGreeting',
    method: 'POST',
    params,
  })
}
// 寒暄库管理-删除
export function delGreetingAPI (params) {
  return ax({
    url: '/wlapi/knowledge/delGreeting',
    method: 'POST',
    data:params
  })
}
// 寒暄库管理-启用停用
export function greetOpenCloseAPI (params) {
  return ax({
    url: '/wlapi/knowledge/editIsActive',
    method: 'POST',
    params,
  })
}